import { esCore } from './es/core';
import { esEntities } from './es/entities';
import { esPlanning } from './es/planning';
import { esStock } from './es/stock';

/**
 * One fragment per area so each change touches the catalog of what it changes:
 * core (app, pages, shared, auth, sync, settings, trash, access) · entities ·
 * stock (inventory, shopping, dashboard) · planning (tasks, documents, notes).
 */
export const es: Readonly<Record<string, string>> = { ...esCore, ...esEntities, ...esStock, ...esPlanning };
